import { $ as de, a as B, b as se, c as k, _ as R, d as Ee, e as xe, f as ye, g as j, h as P, i as Ce, j as _e, k as he, l as ge } from "../index-oCgrS4gV.js";
import * as L from "react";
import g, { forwardRef as S, createElement as l, useState as H, useRef as _, useCallback as z, useEffect as F, useMemo as Pe, Fragment as le } from "react";
import { createPortal as Re } from "react-dom";
import { c as ae } from "../cn-Edy-X8i3.js";
import "clsx";
import "tailwind-merge";
function Se(e) {
  const t = e + "CollectionProvider", [r, o] = de(t), [d, u] = r(t, {
    collectionRef: {
      current: null
    },
    itemMap: /* @__PURE__ */ new Map()
  }), p = (E) => {
    const { scope: w, children: i } = E, n = g.useRef(null), b = g.useRef(/* @__PURE__ */ new Map()).current;
    return /* @__PURE__ */ g.createElement(d, {
      scope: w,
      itemMap: b,
      collectionRef: n
    }, i);
  }, f = e + "CollectionSlot", v = /* @__PURE__ */ g.forwardRef((E, w) => {
    const { scope: i, children: n } = E, b = u(f, i), c = B(w, b.collectionRef);
    return /* @__PURE__ */ g.createElement(se, {
      ref: c
    }, n);
  }), a = e + "CollectionItemSlot", x = "data-radix-collection-item", y = /* @__PURE__ */ g.forwardRef((E, w) => {
    const { scope: i, children: n, ...b } = E, c = g.useRef(null), m = B(w, c), $ = u(a, i);
    return g.useEffect(() => ($.itemMap.set(c, {
      ref: c,
      ...b
    }), () => void $.itemMap.delete(c))), /* @__PURE__ */ g.createElement(se, {
      [x]: "",
      ref: m
    }, n);
  });
  function D(E) {
    const w = u(e + "CollectionConsumer", E);
    return g.useCallback(() => {
      const n = w.collectionRef.current;
      if (!n)
        return [];
      const b = Array.from(n.querySelectorAll(`[${x}]`));
      return Array.from(w.itemMap.values()).sort(
        ($, T) => b.indexOf($.ref.current) - b.indexOf(T.ref.current)
      );
    }, [
      w.collectionRef,
      w.itemMap
    ]);
  }
  return [
    {
      Provider: p,
      Slot: v,
      ItemSlot: y
    },
    D,
    o
  ];
}
const ue = /* @__PURE__ */ S((e, t) => /* @__PURE__ */ l(k.span, R({}, e, {
  ref: t,
  style: {
    // See: https://github.com/twbs/bootstrap/blob/master/scss/mixins/_screen-reader.scss
    position: "absolute",
    border: 0,
    width: 1,
    height: 1,
    padding: 0,
    margin: -1,
    overflow: "hidden",
    clip: "rect(0, 0, 0, 0)",
    whiteSpace: "nowrap",
    wordWrap: "normal",
    ...e.style
  }
}))), pe = "ToastProvider", [ne, Ie, Ae] = Se("Toast"), [fe, dt] = de("Toast", [
  Ae
]), [De, G] = fe(pe), be = (e) => {
  const { __scopeToast: t, label: r = "Notification", duration: o = 5e3, swipeDirection: d = "right", swipeThreshold: u = 50, children: p } = e, [f, v] = H(null), [a, x] = H(0), y = _(!1), D = _(!1);
  return /* @__PURE__ */ l(ne.Provider, {
    scope: t
  }, /* @__PURE__ */ l(De, {
    scope: t,
    label: r,
    duration: o,
    swipeDirection: d,
    swipeThreshold: u,
    toastCount: a,
    viewport: f,
    onViewportChange: v,
    onToastAdd: z(
      () => x(
        (E) => E + 1
      ),
      []
    ),
    onToastRemove: z(
      () => x(
        (E) => E - 1
      ),
      []
    ),
    isFocusedToastEscapeKeyDownRef: y,
    isClosePausedRef: D
  }, p));
};
be.propTypes = {
  label(e) {
    if (e.label && typeof e.label == "string" && !e.label.trim()) {
      const t = `Invalid prop \`label\` supplied to \`${pe}\`. Expected non-empty \`string\`.`;
      return new Error(t);
    }
    return null;
  }
};
const Me = "ToastViewport", Fe = [
  "F8"
], te = "toast.viewportPause", oe = "toast.viewportResume", Oe = /* @__PURE__ */ S((e, t) => {
  const { __scopeToast: r, hotkey: o = Fe, label: d = "Notifications ({hotkey})", ...u } = e, p = G(Me, r), f = Ie(r), v = _(null), a = _(null), x = _(null), y = _(null), D = B(t, y, p.onViewportChange), E = o.join("+").replace(/Key/g, "").replace(/Digit/g, ""), w = p.toastCount > 0;
  F(() => {
    const n = (b) => {
      var c;
      o.every(
        ($) => b[$] || b.code === $
      ) && ((c = y.current) === null || c === void 0 || c.focus());
    };
    return document.addEventListener("keydown", n), () => document.removeEventListener("keydown", n);
  }, [
    o
  ]), F(() => {
    const n = v.current, b = y.current;
    if (w && n && b) {
      const c = () => {
        if (!p.isClosePausedRef.current) {
          const C = new CustomEvent(te);
          b.dispatchEvent(C), p.isClosePausedRef.current = !0;
        }
      }, m = () => {
        if (p.isClosePausedRef.current) {
          const C = new CustomEvent(oe);
          b.dispatchEvent(C), p.isClosePausedRef.current = !1;
        }
      }, $ = (C) => {
        !n.contains(C.relatedTarget) && m();
      }, T = () => {
        n.contains(document.activeElement) || m();
      };
      return n.addEventListener("focusin", c), n.addEventListener("focusout", $), n.addEventListener("pointermove", c), n.addEventListener("pointerleave", T), window.addEventListener("blur", c), window.addEventListener("focus", m), () => {
        n.removeEventListener("focusin", c), n.removeEventListener("focusout", $), n.removeEventListener("pointermove", c), n.removeEventListener("pointerleave", T), window.removeEventListener("blur", c), window.removeEventListener("focus", m);
      };
    }
  }, [
    w,
    p.isClosePausedRef
  ]);
  const i = z(({ tabbingDirection: n }) => {
    const c = f().map((m) => {
      const $ = m.ref.current, T = [
        $,
        ...Qe($)
      ];
      return n === "forwards" ? T : T.reverse();
    });
    return (n === "forwards" ? c.reverse() : c).flat();
  }, [
    f
  ]);
  return F(() => {
    const n = y.current;
    if (n) {
      const b = (c) => {
        const m = c.altKey || c.ctrlKey || c.metaKey;
        if (c.key === "Tab" && !m) {
          const K = document.activeElement, O = c.shiftKey;
          if (c.target === n && O) {
            var T;
            (T = a.current) === null || T === void 0 || T.focus();
            return;
          }
          const M = i({
            tabbingDirection: O ? "backwards" : "forwards"
          }), U = M.findIndex(
            (s) => s === K
          );
          if (ee(M.slice(U + 1)))
            c.preventDefault();
          else {
            var C, I;
            O ? (C = a.current) === null || C === void 0 || C.focus() : (I = x.current) === null || I === void 0 || I.focus();
          }
        }
      };
      return n.addEventListener("keydown", b), () => n.removeEventListener("keydown", b);
    }
  }, [
    f,
    i
  ]), /* @__PURE__ */ l(Ee, {
    ref: v,
    role: "region",
    "aria-label": d.replace("{hotkey}", E),
    tabIndex: -1,
    style: {
      pointerEvents: w ? void 0 : "none"
    }
  }, w && /* @__PURE__ */ l(ce, {
    ref: a,
    onFocusFromOutsideViewport: () => {
      const n = i({
        tabbingDirection: "forwards"
      });
      ee(n);
    }
  }), /* @__PURE__ */ l(ne.Slot, {
    scope: r
  }, /* @__PURE__ */ l(k.ol, R({
    tabIndex: -1
  }, u, {
    ref: D
  }))), w && /* @__PURE__ */ l(ce, {
    ref: x,
    onFocusFromOutsideViewport: () => {
      const n = i({
        tabbingDirection: "backwards"
      });
      ee(n);
    }
  }));
}), Ne = "ToastFocusProxy", ce = /* @__PURE__ */ S((e, t) => {
  const { __scopeToast: r, onFocusFromOutsideViewport: o, ...d } = e, u = G(Ne, r);
  return /* @__PURE__ */ l(ue, R({
    "aria-hidden": !0,
    tabIndex: 0
  }, d, {
    ref: t,
    style: {
      position: "fixed"
    },
    onFocus: (p) => {
      var f;
      const v = p.relatedTarget;
      !((f = u.viewport) !== null && f !== void 0 && f.contains(v)) && o();
    }
  }));
}), J = "Toast", Le = "toast.swipeStart", ke = "toast.swipeMove", Ke = "toast.swipeCancel", Ve = "toast.swipeEnd", We = /* @__PURE__ */ S((e, t) => {
  const { forceMount: r, open: o, defaultOpen: d, onOpenChange: u, ...p } = e, [f = !0, v] = xe({
    prop: o,
    defaultProp: d,
    onChange: u
  });
  return /* @__PURE__ */ l(ye, {
    present: r || f
  }, /* @__PURE__ */ l($e, R({
    open: f
  }, p, {
    ref: t,
    onClose: () => v(!1),
    onPause: j(e.onPause),
    onResume: j(e.onResume),
    onSwipeStart: P(e.onSwipeStart, (a) => {
      a.currentTarget.setAttribute("data-swipe", "start");
    }),
    onSwipeMove: P(e.onSwipeMove, (a) => {
      const { x, y } = a.detail.delta;
      a.currentTarget.setAttribute("data-swipe", "move"), a.currentTarget.style.setProperty("--radix-toast-swipe-move-x", `${x}px`), a.currentTarget.style.setProperty("--radix-toast-swipe-move-y", `${y}px`);
    }),
    onSwipeCancel: P(e.onSwipeCancel, (a) => {
      a.currentTarget.setAttribute("data-swipe", "cancel"), a.currentTarget.style.removeProperty("--radix-toast-swipe-move-x"), a.currentTarget.style.removeProperty("--radix-toast-swipe-move-y"), a.currentTarget.style.removeProperty("--radix-toast-swipe-end-x"), a.currentTarget.style.removeProperty("--radix-toast-swipe-end-y");
    }),
    onSwipeEnd: P(e.onSwipeEnd, (a) => {
      const { x, y } = a.detail.delta;
      a.currentTarget.setAttribute("data-swipe", "end"), a.currentTarget.style.removeProperty("--radix-toast-swipe-move-x"), a.currentTarget.style.removeProperty("--radix-toast-swipe-move-y"), a.currentTarget.style.setProperty("--radix-toast-swipe-end-x", `${x}px`), a.currentTarget.style.setProperty("--radix-toast-swipe-end-y", `${y}px`), v(!1);
    })
  })));
}), [He, Ue] = fe(J, {
  onClose() {
  }
}), $e = /* @__PURE__ */ S((e, t) => {
  const { __scopeToast: r, type: o = "foreground", duration: d, open: u, onClose: p, onEscapeKeyDown: f, onPause: v, onResume: a, onSwipeStart: x, onSwipeMove: y, onSwipeCancel: D, onSwipeEnd: E, ...w } = e, i = G(J, r), [n, b] = H(null), c = B(
    t,
    (s) => b(s)
  ), m = _(null), $ = _(null), T = d || i.duration, C = _(0), I = _(T), K = _(0), { onToastAdd: O, onToastRemove: Q } = i, N = j(() => {
    var s;
    (n == null ? void 0 : n.contains(document.activeElement)) && ((s = i.viewport) === null || s === void 0 || s.focus()), p();
  }), M = z((s) => {
    !s || s === 1 / 0 || (window.clearTimeout(K.current), C.current = (/* @__PURE__ */ new Date()).getTime(), K.current = window.setTimeout(N, s));
  }, [
    N
  ]);
  F(() => {
    const s = i.viewport;
    if (s) {
      const h = () => {
        M(I.current), a == null || a();
      }, A = () => {
        const V = (/* @__PURE__ */ new Date()).getTime() - C.current;
        I.current = I.current - V, window.clearTimeout(K.current), v == null || v();
      };
      return s.addEventListener(te, A), s.addEventListener(oe, h), () => {
        s.removeEventListener(te, A), s.removeEventListener(oe, h);
      };
    }
  }, [
    i.viewport,
    T,
    v,
    a,
    M
  ]), F(() => {
    u && !i.isClosePausedRef.current && M(T);
  }, [
    u,
    T,
    i.isClosePausedRef,
    M
  ]), F(() => (O(), () => Q()), [
    O,
    Q
  ]);
  const U = Pe(() => n ? ve(n) : null, [
    n
  ]);
  return i.viewport ? /* @__PURE__ */ l(le, null, U && /* @__PURE__ */ l(Xe, {
    __scopeToast: r,
    role: "status",
    "aria-live": o === "foreground" ? "assertive" : "polite",
    "aria-atomic": !0
  }, U), /* @__PURE__ */ l(He, {
    scope: r,
    onClose: N
  }, /* @__PURE__ */ Re(/* @__PURE__ */ l(ne.ItemSlot, {
    scope: r
  }, /* @__PURE__ */ l(Ce, {
    asChild: !0,
    onEscapeKeyDown: P(f, () => {
      i.isFocusedToastEscapeKeyDownRef.current || N(), i.isFocusedToastEscapeKeyDownRef.current = !1;
    })
  }, /* @__PURE__ */ l(k.li, R({
    // Ensure toasts are announced as status list or status when focused
    role: "status",
    "aria-live": "off",
    "aria-atomic": !0,
    tabIndex: 0,
    "data-state": u ? "open" : "closed",
    "data-swipe-direction": i.swipeDirection
  }, w, {
    ref: c,
    style: {
      userSelect: "none",
      touchAction: "none",
      ...e.style
    },
    onKeyDown: P(e.onKeyDown, (s) => {
      s.key === "Escape" && (f == null || f(s.nativeEvent), s.nativeEvent.defaultPrevented || (i.isFocusedToastEscapeKeyDownRef.current = !0, N()));
    }),
    onPointerDown: P(e.onPointerDown, (s) => {
      s.button === 0 && (m.current = {
        x: s.clientX,
        y: s.clientY
      });
    }),
    onPointerMove: P(e.onPointerMove, (s) => {
      if (!m.current)
        return;
      const h = s.clientX - m.current.x, A = s.clientY - m.current.y, V = !!$.current, W = [
        "left",
        "right"
      ].includes(i.swipeDirection), X = [
        "left",
        "up"
      ].includes(i.swipeDirection) ? Math.min : Math.max, we = W ? X(0, h) : 0, Te = W ? 0 : X(0, A), Z = s.pointerType === "touch" ? 10 : 2, Y = {
        x: we,
        y: Te
      }, re = {
        originalEvent: s,
        delta: Y
      };
      V ? ($.current = Y, q(ke, y, re, {
        discrete: !1
      })) : ie(Y, i.swipeDirection, Z) ? ($.current = Y, q(Le, x, re, {
        discrete: !1
      }), s.target.setPointerCapture(s.pointerId)) : (Math.abs(h) > Z || Math.abs(A) > Z) && (m.current = null);
    }),
    onPointerUp: P(e.onPointerUp, (s) => {
      const h = $.current, A = s.target;
      if (A.hasPointerCapture(s.pointerId) && A.releasePointerCapture(s.pointerId), $.current = null, m.current = null, h) {
        const V = s.currentTarget, W = {
          originalEvent: s,
          delta: h
        };
        ie(h, i.swipeDirection, i.swipeThreshold) ? q(Ve, E, W, {
          discrete: !0
        }) : q(Ke, D, W, {
          discrete: !0
        }), V.addEventListener(
          "click",
          (X) => X.preventDefault(),
          {
            once: !0
          }
        );
      }
    })
  })))), i.viewport))) : null;
});
$e.propTypes = {
  type(e) {
    if (e.type && ![
      "foreground",
      "background"
    ].includes(e.type)) {
      const t = `Invalid prop \`type\` supplied to \`${J}\`. Expected \`foreground | background\`.`;
      return new Error(t);
    }
    return null;
  }
};
const Xe = (e) => {
  const { __scopeToast: t, children: r, ...o } = e, d = G(J, t), [u, p] = H(!1), [f, v] = H(!1);
  return Ge(
    () => p(!0)
  ), F(() => {
    const a = window.setTimeout(
      () => v(!0),
      1e3
    );
    return () => window.clearTimeout(a);
  }, []), f ? null : /* @__PURE__ */ l(_e, {
    asChild: !0
  }, /* @__PURE__ */ l(ue, o, u && /* @__PURE__ */ l(le, null, d.label, " ", r)));
}, Ye = /* @__PURE__ */ S((e, t) => {
  const { __scopeToast: r, ...o } = e;
  return /* @__PURE__ */ l(k.div, R({}, o, {
    ref: t
  }));
}), qe = "ToastAction", Be = /* @__PURE__ */ S((e, t) => {
  const { altText: r, ...o } = e;
  return r ? /* @__PURE__ */ l(me, {
    altText: r,
    asChild: !0
  }, /* @__PURE__ */ l(ze, R({}, o, {
    ref: t
  }))) : null;
});
Be.propTypes = {
  altText(e) {
    return e.altText ? null : new Error(`Missing prop \`altText\` expected on \`${qe}\``);
  }
};
const je = "ToastClose", ze = /* @__PURE__ */ S((e, t) => {
  const { __scopeToast: r, ...o } = e, d = Ue(je, r);
  return /* @__PURE__ */ l(me, {
    asChild: !0
  }, /* @__PURE__ */ l(k.button, R({
    type: "button"
  }, o, {
    ref: t,
    onClick: P(e.onClick, d.onClose)
  })));
}), me = /* @__PURE__ */ S((e, t) => {
  const { __scopeToast: r, altText: o, ...d } = e;
  return /* @__PURE__ */ l(k.div, R({
    "data-radix-toast-announce-exclude": "",
    "data-radix-toast-announce-alt": o || void 0
  }, d, {
    ref: t
  }));
});
function ve(e) {
  const t = [];
  return Array.from(e.childNodes).forEach((o) => {
    if (o.nodeType === o.TEXT_NODE && o.textContent && t.push(o.textContent), Je(o)) {
      const d = o.ariaHidden || o.hidden || o.style.display === "none", u = o.dataset.radixToastAnnounceExclude === "";
      if (!d)
        if (u) {
          const p = o.dataset.radixToastAnnounceAlt;
          p && t.push(p);
        } else
          t.push(...ve(o));
    }
  }), t;
}
function q(e, t, r, { discrete: o }) {
  const d = r.originalEvent.currentTarget, u = new CustomEvent(e, {
    bubbles: !0,
    cancelable: !0,
    detail: r
  });
  t && d.addEventListener(e, t, {
    once: !0
  }), o ? he(d, u) : d.dispatchEvent(u);
}
const ie = (e, t, r = 0) => {
  const o = Math.abs(e.x), d = Math.abs(e.y), u = o > d;
  return t === "left" || t === "right" ? u && o > r : !u && d > r;
};
function Ge(e = () => {
}) {
  const t = j(e);
  ge(() => {
    let r = 0, o = 0;
    return r = window.requestAnimationFrame(
      () => o = window.requestAnimationFrame(t)
    ), () => {
      window.cancelAnimationFrame(r), window.cancelAnimationFrame(o);
    };
  }, [
    t
  ]);
}
function Je(e) {
  return e.nodeType === e.ELEMENT_NODE;
}
function Qe(e) {
  const t = [], r = document.createTreeWalker(e, NodeFilter.SHOW_ELEMENT, {
    acceptNode: (o) => {
      const d = o.tagName === "INPUT" && o.type === "hidden";
      return o.disabled || o.hidden || d ? NodeFilter.FILTER_SKIP : o.tabIndex >= 0 ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_SKIP;
    }
  });
  for (; r.nextNode(); )
    t.push(r.currentNode);
  return t;
}
function ee(e) {
  const t = document.activeElement;
  return e.some((r) => r === t ? !0 : (r.focus(), document.activeElement !== t));
}
const Ze = be, et = Oe, tt = We, ot = Ye;
function lt(e) {
  return /* @__PURE__ */ L.createElement(
    Ze,
    {
      swipeDirection: e.swipeDirection ?? "right",
      duration: e.duration ?? 4e3
    },
    e.children
  );
}
function ut(e) {
  return /* @__PURE__ */ L.createElement(L.Fragment, null, /* @__PURE__ */ L.createElement(
    tt,
    {
      className: ae(
        "mx-4 rounded bg-black px-4 py-3 text-primary-inverted shadow-[hsl(206_22%_7%_/_35%)_0px_10px_38px_-10px,_hsl(206_22%_7%_/_20%)_0px_10px_20px_-15px]",
        e.className
      ),
      open: e.isOpen,
      onOpenChange: e.onOpenChange
    },
    /* @__PURE__ */ L.createElement(ot, { asChild: !0 }, e.children)
  ), /* @__PURE__ */ L.createElement(
    et,
    {
      className: ae("list-none fixed z-700", e.viewportClassName)
    }
  ));
}
export {
  ut as Toast,
  lt as ToastProvider
};
